'use strict';

module.exports = function () {
    $('body').on('store:storepickup-reserve', function (e, response) {
        var productId = response.data.productId || null;
        var storeId = response.data.storeId || null;
        var actionUrl = response.data.hopsActionUrl || null;
        var inStock = response.data.inStock || false;
        var callStore = response.data.callStore || null;
        if (storeId && productId && actionUrl) {
            $.spinner().start();
            var url = actionUrl + '?pid=' + productId + '&sid=' + storeId + '&instock=' + inStock;
            if (callStore) {
                url += '&callStore=' + true;
            }
            $.get(url, function (dialog) {
                require('./hops/hops').showHOPSDialog(dialog);
                require('org/components/input').initInputLabels();
            }).always(function () {
                $.spinner().stop();
            });
        }
    });
};
